export default __webpack_public_path__ + "static/media/before@3x.53df004e.jpg";